import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import IndustriesPage from "../pages/industries/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/industries",
    element: <IndustriesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
